import { fontWeight } from "@mui/system";
import React, {useState, useEffect} from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useMediaQuery } from 'react-responsive';
import ContactCard from '../../components/ContactCard';

function Contact() {
  const text = {
    padding: "auto",
    margin: "auto",
    textAlign: "center",
    paddingBottom: 20,
  }
  return (
    <section>
        <Container className="contact-section" id="contact">
            <div style={text}>
            <ContactCard/>
            </div>            
        </Container>
    </section>
    
  );
}

export default Contact;
